<template>
<section class="footer">
    <a class="footerEmail" href="mailto:info@evntl.com" target="_blank">{{email}}</a>
    <div class="footerNumber">1-800-555-4247</div>
    <div class="footerIcons">
      <img class="icons" :src="facebook" alt="facebook" @click="toFacebook" v-if="false">
      <img class="icons" :src="twitter" alt="twitter" @click="toTwitter">
      <img class="icons" :src="linkedin" alt="linkedin" @click="toLinkedin">
    </div>
  </section>
</template>

<script>
import Facebook from '@/assets/facebook.svg';
import Twitter from '@/assets/twitter.svg';
import Linkedin from '@/assets/linkedin.svg';

export default {
  name: 'Footer',
  data() {
    return {
      email: 'info@highground.com',
      twitter: Twitter,
      facebook: Facebook,
      linkedin: Linkedin
    }
  },
  methods: {
    toFacebook() {
      let url = "https://facebook.com/";
      window.open(url, "_blank");
    },
    toTwitter() {
      let url = "https://twitter.com/EVNTL_ai";
      window.open(url, "_blank");
    },
    toLinkedin() {
      let url = "https://www.linkedin.com/company/evntl/";
      window.open(url, "_blank");
    }
  },
}
</script>

<style scoped>
@media (min-width: 400px) {
  .footer {
    position: relative;
    height: 15rem;
    width: 100%;
    background: #1e1e1e;
    color: white;
    text-align: center;
  }
  .footerNumber {
    margin: 0.5rem 0;
    font-size: 1.8vw;
  }
  .icons {
    height: auto;
    margin-top: 1rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    cursor: pointer;
    width: 3%;
  }
}
@media (max-width: 400px) {
  .footer {
    position: relative;
    height: 5rem;
    width: 100%;
    background: #1e1e1e;
    color: white;
    text-align: center;
  }
  .footerNumber {
    margin: 0.5rem 0 0 0;
    font-size: 1.3vw;
  }
  .icons {
    height: auto;
    margin-top: 0.5rem;
    margin-left: 0.2rem;
    margin-right: 0.2rem;
    cursor: pointer;
    width: 3%;
  }
}
.footerEmail {
  font-size: 1.7vw;
  text-decoration: none;
  color: white;
  cursor: pointer;
}
.footerIcons {
  position: relative;
}
.icons {
  height: auto;
  margin-top: 1rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
  width: 3%;
}
</style>

